import React, { useEffect, useState } from 'react';
import { addDiConnectionDetails } from '../../../common/helper/api.helper';
import {
  FETCH_SUCCESS,
  FETCH_ERROR,
  DEDICATED_FEASIBILITY_RESPONSE,
  MODULE_ID,
  DEDICATED_CUSTOMER_DETAIL,
  LEAD_STATUS,
  LEAD_STATUS_MSG,
  PROCEED_CONFIRMATION,
  ATTRIBUTE_TEXT
} from '../../../home/common/constants/constants';
import './stripComponent.scss';
import useApiHook from '../../../home/components/customHook/apiHook';
import { stopBackgroundScrolling, getFromSessionStorage, numberWithCommas } from '../../../common/utils/app.utils';
import { useHistory } from 'react-router-dom';
import { MOENGAGE_ANALYTICS_EVENT, PRODUCT_NAME, PRODUCT_TYPE } from '../../../common/constants/app.constants';
import { trackMOEEvent } from '../../../common/services/moengage.service';
import {
  faOnDedicatedConfirmClick,
  faOnDedicatedNeedAssistanceClick,
  faOnDedicatedCancelClick,
  faOnDedicatedPlanProceedClick,
  faOnDedicatedBookingSummaryModalLoad,
  faOnDedicatedBookingSummaryModalSubmit,
  faOnDedicatedCancelOrderPopupLoad,
  faOnDedicatedCancelOrderPopupSubmit,
  faOnDedicatedSaveOrderClick
} from '../../../dedicated/services/analytics.service';
import Button from 'b2b-ui-components-lib/lib/components/button';
import CustomModal from '../customModal/customModal';
import CancelOrderPopup from '../cancelOrderPopup/cancelOrderPopup';
import { MEDIA_TYPES } from 'dedicated/components/choose-plan/plan.service';
import { HARDWARE_TYPE } from 'home/view/manage-feasibility/constants';

const StripComponent = (props) => {
  let {
    selectedIpAttributes,
    selectedHardwareType,
    ipAttributeType,
    selectedPlan,
    contractPeriod,
    servicetype,
    leadStatus,
    leadDetails,
    fetchLead,
    selectedRouter,
    submitLead,
    feasibilityData = {},
    selectedPrimaryMedia = {},
    itemCode,
    selectedRateCardId
  } = props;
  let [showAssistPopup, setshowAssistPopup] = useState(false);
  let [showManualFeasibilityMsg, setShowManualFeasibilityMsg] = useState(
    leadDetails &&
      leadDetails.feasibilityStatus &&
      leadDetails.feasibilityStatus.toUpperCase() === LEAD_STATUS.MANUAL_INTERVENTION_REQUIRED &&
      (leadStatus.toUpperCase() !== LEAD_STATUS.FEASIBILITY_PENDING || leadStatus.toUpperCase() !== LEAD_STATUS.PNQ_IN_PROGRESS)
      ? true
      : false
  );
  let [toggleConfirmationPopup, setToggleConfirmationPopup] = useState(false);
  const [fetchState, setAPIFetechingState] = useApiHook();
  let contractPeriodValue = selectedPlan && Object.keys(selectedPlan).length > 1 && selectedPlan.price && contractPeriod && contractPeriod.value ? contractPeriod.value : '';
  let history = useHistory();
  const ipAttribute = ipAttributeType ? ATTRIBUTE_TEXT.NON_STANDARD : ATTRIBUTE_TEXT.STANDARD;

  const submitOrder = () => {
    proceedOrder();
    const params = {
      ...selectedPlan,
      planPeriod: contractPeriod.value * 12,
      ipAttribute
    };
    faOnDedicatedPlanProceedClick(params);
  };
  const proceedOrder = () => {
    setToggleConfirmationPopup(!toggleConfirmationPopup);
  };
  const customPopupSubmit = () => {
    setToggleConfirmationPopup(!toggleConfirmationPopup);
    confirmClickHandler();
    faOnDedicatedBookingSummaryModalSubmit();
  };
  const saveOrder = () => {
    confirmClickHandler();
    faOnDedicatedSaveOrderClick();
  };
  const confirmClickHandler = () => {
    if (leadStatus === LEAD_STATUS.PNQ_COMPLETED && leadDetails && (leadDetails.doaStatus === 'APPROVED' || !leadDetails.doaStatus || leadDetails.doaStatus === 'AUTO_APPROVED')) {
      submitLead(leadDetails);
    } else {
      props.setisLoading(true);
      let feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
      let connectionDetails = getFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL);
      let payload = {};
      // payload.push({...connectionDetails});
      if (selectedPlan && selectedPlan.service === 'UNMANAGED') {
        selectedPlan.routerSpecs = null;
      } else if (selectedPlan && selectedPlan.id >= 0 && selectedPlan.service === 'MANAGED') {
        selectedPlan.routerSpecs = selectedRouter && selectedRouter[selectedPlan.id] && [selectedRouter[selectedPlan.id]];
      }
      if (selectedPlan && Object.keys(selectedPlan.specs).length > 1) {
        selectedPlan.specs = selectedPlan.specs;
      } else {
        selectedPlan.specs = selectedIpAttributes;
      }

      if (Array.isArray(selectedPlan.specs)) {
        selectedPlan?.specs?.push({
          name: 'hardwareType',
          value: HARDWARE_TYPE[selectedHardwareType?.value],
          linkType: 'PRIMARY',
          commercial: false
        });
      }
      let newplan = { ...selectedPlan, planPeriod: contractPeriod.value * 12 };

      if (selectedRateCardId?.key) {
        newplan['rateCardId'] = selectedRateCardId?.key;
      }

      // set itemCode in payload
      if (Array.isArray(newplan?.routerSpecs) && newplan?.routerSpecs?.length > 0 && itemCode) {
        newplan?.routerSpecs?.map((item) => {
          if (item['make'] && item['model']) {
            item['itemCode'] = itemCode;
          }
        });
      }

      trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.AUTH_SUBMIT_PLAN, { ...selectedPlan });
      let feasibilityId = feasibilityResponse && feasibilityResponse.feasibilityId;
      let feasibilityStatus = feasibilityResponse && feasibilityResponse.feasibilityStatus;
      if (!feasibilityId) {
        feasibilityId = leadDetails && leadDetails.feasibilityId;
      }
      if (!feasibilityStatus) {
        feasibilityStatus = leadDetails && leadDetails.feasibilityStatus;
      }
      faOnDedicatedConfirmClick(newplan);
      payload = { planDetail: newplan, feasibilityId: feasibilityId, feasibilityStatus: feasibilityStatus, ...connectionDetails };

      // set selected media(s) in diConnection req object

      const isMPLS = getFromSessionStorage(MODULE_ID, PRODUCT_NAME) === PRODUCT_TYPE.VPN;

      const isSiteManualFeasible = feasibilityData && feasibilityData.feasibilityStatus === 'MANUAL_INTERVENTION_REQUIRED';
      const isSitePendingThirdParty = feasibilityData && feasibilityData.feasibilityStatus === 'PENDING_FOR_THIRD_PARTY';

      const selectedMedia = [];

      if (!isSiteManualFeasible || !isSitePendingThirdParty) {
        if (selectedPrimaryMedia && selectedPrimaryMedia.key) {
          selectedMedia.push({
            media: selectedPrimaryMedia.key,
            primary: true
          });

          // Dual LM case
          if (feasibilityData && feasibilityData.dualLastMile && isMPLS) {
            selectedMedia.push({
              media: 'THIRD_PARTY',
              primary: false
            });
          }
        }
      }

      if (selectedMedia.length > 0) {
        payload = { ...payload, selectedMedia };
      }

      console.log('payload 1', payload);
      addDiConnectionDetails([payload])
        .then((response) => {
          setshowAssistPopup(false);
          setAPIFetechingState({ type: FETCH_SUCCESS });
          props.setisLoading(false);
          fetchLead('SUBMIT_LEAD');
        })
        .catch((err) => {
          props.setisLoading(false);
        });
    }
  };
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [viewMore, setViewMore] = useState(false);

  const onCancel = () => {
    setShowCancelPopup(true);
    faOnDedicatedCancelClick();
  };

  const onViewMoreLessClick = () => {
    setViewMore(!viewMore);
  };

  const isSelectedMediaTPorOffnet = () => {
    let isMediaTpOrOffnet = false;
    const selectedMedia = (selectedPrimaryMedia && Object.keys(selectedPrimaryMedia).length > 0 && selectedPrimaryMedia.key) || '';

    if (selectedMedia && (selectedMedia === MEDIA_TYPES.OFFNET || selectedMedia === MEDIA_TYPES.THIRD_PARTY)) {
      isMediaTpOrOffnet = true;
    }

    return isMediaTpOrOffnet;
  };

  useEffect(() => {
    document.getElementById('root').className = 'pricing-strip';
    return () => {
      document.getElementById('root').classList.remove('pricing-strip');
    };
  }, []);

  return (
    <React.Fragment>
      <div className={`selected-plans plan-strip-box active`}>
        {/* add class "full_plans" to show pull plan items */}
        <div className="container">
          <div className={`inside-plan ${viewMore ? 'show_full_view' : ''}`}>
            <div className="plan-info">
              <div className="plan_details_veiw">
                <div className="left_col">
                  <h4>Total Amount</h4>
                  <div className="value">
                    &#8377;{' '}
                    {selectedPlan && selectedPlan.price
                      ? numberWithCommas((selectedPlan && selectedPlan.price && selectedPlan.price.amount * contractPeriod.value) + (selectedPlan && selectedPlan.price.otc))
                      : '-  '}
                  </div>
                </div>
                <div className="right_col">
                  <div className="view_type" onClick={onViewMoreLessClick}>
                    {viewMore ? 'View Less' : 'View More'} <span className={`animatedarrow ${viewMore ? 'arrow_up' : ''} `}></span>
                  </div>
                </div>
              </div>
              <div className="condition_info">*Additional charges may apply along with taxes.</div>
            </div>
            <div className="plan-details">
              <div className="item_list">
                <div className="items tital_for_mobile">
                  <div className="label">Selected Plan</div>
                  <div className="value">
                    <strong>{selectedPlan && selectedPlan.speed ? '1' : '-'} </strong>
                  </div>
                </div>
                <div className="items border-bottom">
                  <div className="label">Selected Bandwidth</div>
                  <div className="value">
                    <strong>{selectedPlan && selectedPlan.speed ? selectedPlan.speed : '-'} </strong>
                    {/* <small>Mbps</small> */}
                  </div>
                </div>
                <div className="items">
                  <div className="label">Service Type</div>
                  <div className="value">
                    <strong>
                      {servicetype ? servicetype : '-'}, {ipAttribute}
                    </strong>
                  </div>
                </div>
                <div className="items">
                  <div className="label">Contract Period</div>
                  <div className="value">
                    <strong> {contractPeriodValue ? (contractPeriodValue === 1 ? contractPeriodValue + ' Year' : contractPeriodValue + ' Years') : '-'} </strong>
                  </div>
                </div>
              </div>
              <div className="action">
                <Button variant="outlinebtn" onClick={onCancel}>
                  Cancel
                </Button>
                {selectedPlan && selectedPlan.price ? (
                  <React.Fragment>
                    {leadDetails &&
                    leadDetails.feasibilityStatus &&
                    leadDetails.feasibilityStatus.toUpperCase() === LEAD_STATUS.MANUAL_INTERVENTION_REQUIRED &&
                    !ipAttributeType ? (
                      <Button className="activebtn" onClick={saveOrder}>
                        Save Order
                      </Button>
                    ) : (
                      <Button className="activebtn" onClick={submitOrder}>
                        {' '}
                        Proceed
                      </Button>
                    )}
                  </React.Fragment>
                ) : (
                  <Button disabled={true} className="activebtn">
                    {leadDetails && leadDetails.feasibilityStatus && leadDetails.feasibilityStatus.toUpperCase() === LEAD_STATUS.MANUAL_INTERVENTION_REQUIRED
                      ? 'Save Order'
                      : 'Proceed'}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showCancelPopup && (
        <CancelOrderPopup
          onLoad={faOnDedicatedCancelOrderPopupLoad}
          onSubmit={(data) => faOnDedicatedCancelOrderPopupSubmit(data)}
          setshowPopup={setShowCancelPopup}
          isSummaryPage={false}
          isCustomerCancel={true}
        ></CancelOrderPopup>
      )}
      {toggleConfirmationPopup && (
        <CustomModal
          customPopupTitle={
            (ipAttributeType ||
              (selectedHardwareType && selectedHardwareType.value === 'NON_STANDARD') ||
              (selectedPlan && selectedPlan.price && selectedPlan.price.amount === 0)) &&
            leadStatus !== LEAD_STATUS.PNQ_COMPLETED
              ? PROCEED_CONFIRMATION.NOTICE_TITLE
              : PROCEED_CONFIRMATION.CONFIRMATION_TITLE
          }
          customPopupMsg={
            (ipAttributeType ||
              (selectedHardwareType && selectedHardwareType.value === 'NON_STANDARD') ||
              (selectedPlan && selectedPlan.price && selectedPlan.price.amount === 0) ||
              isSelectedMediaTPorOffnet()) &&
            leadStatus !== LEAD_STATUS.PNQ_COMPLETED
              ? PROCEED_CONFIRMATION.NOTICE_MSG
              : PROCEED_CONFIRMATION.CONFIRMATION_MSG
          }
          submitCustomPopup={customPopupSubmit}
          closeCustomPopup={proceedOrder}
          onLoad={faOnDedicatedBookingSummaryModalLoad}
        />
      )}
    </React.Fragment>
  );
};

export default StripComponent;
